import { useParams, useRoutes } from "react-router-dom";
// import { buildRoutes } from '@/routes/index'
 import {buildRoutes} from '@/routes/index'
//  import buildRoutes from "@/routes/index"
import DistributorRoutes from "@/routes/DistributorRoutes";
import RetailerRoutes from "@/routes/RetailerRoutes";
import DisRoutes from "./DisRoutes";

const RoleBasedPrivateRoutes = () => {
    const { role } = useParams();

    const getPrivateRoutesByRole = () => {
      const allRoutes = DisRoutes.privateRoutes;
  
      const filteredRoutes: Record<string, any> = Object.fromEntries(
        Object.entries(allRoutes).filter(([_, route]) => 
          !route.roles || route.roles.includes(role || "")
        )
      );
  
      return filteredRoutes;
    };
  
    return useRoutes(buildRoutes(getPrivateRoutesByRole()));
//   const getPrivateRoutes = () => {
//     switch (role) {
//       case "distributor":
//         return DistributorRoutes;
//       case "retailer":
//         return RetailerRoutes;
//       default:
//         return {};
//     }
//   };

//   return useRoutes(buildRoutes(getPrivateRoutes()));
};

export default RoleBasedPrivateRoutes;
